<template>
    <el-row v-wechat-title="title" class="usage-drug-event">
        <el-col :span="6">
            <el-tabs v-model="activeHandle">
                <el-tab-pane label="用药信息" name="first">
                    <el-divider content-position="left">药品类别</el-divider>
                    <el-scrollbar wrap-class="scrollbar-wrapper-y" style="height: 180px">
                        <item-input type="radio" v-model="drug_type" :options="enumDrugType" :borderd="true"></item-input>
                    </el-scrollbar>
                    <el-divider content-position="left" class="margin20 margin-none-h">药品搜索</el-divider>
                    <item-input type="string" v-model="drug_search_key" placeholder="请输入药品名或拼音首字母"></item-input>
                    <el-scrollbar
                        wrap-class="scrollbar-wrapper-y"
                        class="padding5 margin5 margin-none-h align-left"
                        style="border: solid 0.5px lightgray"
                        :style="{ height: `${this.screenHeight2 - 400}px` }"
                    >
                        <el-link v-for="drug in drug_search_result" class="ellipsis margin5 margin-none-h" :key="drug.value" @dblclick.native="useDrug(drug)">{{ drug.label }}</el-link>
                    </el-scrollbar>
                </el-tab-pane>
                <el-tab-pane label="复合用药" name="second">
                    <el-divider content-position="left" class="margin20 margin-none-h">药品组合搜索</el-divider>
                    <item-input type="string" v-model="compounddrug_search_key" placeholder="请输入药品组合名"></item-input>
                    <el-scrollbar
                        wrap-class="scrollbar-wrapper-y"
                        class="padding5 margin5 margin-none-h align-left"
                        style="border: solid 0.5px lightgray"
                        :style="{ height: `${this.screenHeight2 - 220}px` }"
                    >
                        <el-link v-for="drug in compounddrug_search_result" class="ellipsis margin5 margin-none-h" :key="drug.value" @dblclick.native="compounddruguseDrug(drug)">{{
                            drug.label
                        }}</el-link>
                    </el-scrollbar>
                </el-tab-pane>
                <el-tab-pane label="事件信息" name="third">
                    <!-- <el-divider content-position="left" class="margin20 margin-none-h">事件搜索</el-divider> -->
                    <item-input type="string" v-model="event_search_key" placeholder="请输入事件名或拼音首字母"></item-input>
                    <el-scrollbar
                        wrap-class="scrollbar-wrapper-y"
                        class="padding5 margin5 margin-none-h align-left"
                        style="border: solid 0.5px lightgray"
                        :style="{ height: `${this.screenHeight2 - 178}px` }"
                    >
                        <el-link v-for="event in event_search_result" class="ellipsis margin5 margin-none-h" :key="event.value" @dblclick.native="useEvent(event)"> {{ event.label }} </el-link>
                    </el-scrollbar>
                </el-tab-pane>
            </el-tabs>
        </el-col>
        <el-col :span="18">
            <div class="fg-danger align-left" v-if="activeHandle == 'first' || activeHandle == 'third'" style="padding: 10px 0 5px 20px;font-size: 17px;">提示:列表内操作需确认后生效</div>
            <div class="fg-danger align-left" v-if="activeHandle == 'second'" style="padding: 10px 0 5px 20px">提示:列表内操作即时生效</div>
            <cus-form
                ref="form-saveas"
                v-if="activeHandle == 'first' || activeHandle == 'third'"
                :data="mdata"
                width="95%"
                :columns="columnList"
                @extrabutton-click="ExtraButtonClick"
                @confirm="SaveAs"
            ></cus-form>
            <cus-form
                ref="form-compounddrug"
                v-if="activeHandle == 'second'"
                :data="compoundDrugdata"
                width="95%"
                :columns="columnListCompounddrug"
                @extrabutton-click="ExtraButtonClick"
                @confirm="SaveAs"
            ></cus-form>
            <CloseButton ref="close-btn" type="confirm" @confirm="confirm" :msg="msg"> </CloseButton>
        </el-col>
        <cus-dialog class="table-h360" title="复合用药" :visible.sync="compoundDrug.dialogFormVisible" :close-on-click-modal="false" width="60%" @confirm="savecompoundDrug">
            <cus-form ref="form-compoundDrug" :columns="from1columnList" :data="compoundDrug.fromdata" @extrabutton-click="ExtraButtonClick" @confirm="savecompoundDrugIn"> </cus-form>
            <ListView :columns="listcolumnList" :rowNoStyle="true" :datalist="compoundDrug.listdata"></ListView>
            <!-- <ListView :columns="listcolumnList" :rowNoStyle="true" :datalist="Analgesicdetail.listdata"></ListView> -->
        </cus-dialog>
    </el-row>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
    name: `UsageDrugEvent`,
    props: {
        visible: { type: Boolean, default: () => false }
        // data:{type:Object}
    },
    data() {
        return {
            title: `用药及事件`,
            decimalPlaces: 3,
            surgeryId: this.$route.query.surgery_id,
            recordType: this.$route.query.record_type,
            token: this.$route.query.token,
            dic_event_config: [],
            dic_event_keyvalues: [],
            dic_key_eventnames: [],
            InfusionChannel: [],
            key_events: [],
            nodeleted_events: [],
            readonly_events: [],
            mdata: {},
            compoundDrugdata: {},
            msg: `closeWindow`,
            removeItems: [],
            activeHandle: `first`,
            drug_type: undefined,
            drug_search_key: ``,
            compounddrug_search_key: ``,
            drug_search_result: [],
            compounddrug_search_result: [],
            event_search_key: ``,
            dialogFormVisible: false,
            permissions: [],
            compoundDrug: {
                dialogFormVisible: false,
                fromdata: {
                    id: null,
                    dic_compound_drug_group_code: ``,
                    dic_compound_drug_group_name: ``,
                    group_type_id: null,
                    is_continue: false,
                    begin_time: this.$moment().format(`YYYY/MM/DD HH:mm:ss`),
                    end_time: null,
                    concentration: ``,
                    concentration_unit: ``,
                    unit: ``,
                    add_drug_way: ``,
                    dic_infusion_channel_id: null
                },
                listdata: []
            },
            utilityPromise: Promise.resolve(),
            rawData: {
                biz_surgery_info_id: 0,
                id: 0,
                is_key_event: false,
                item: {
                    label: ``,
                    value: 0
                },
                item_type: -1,
                occur_time: null,
                remark: ``
            },
            isShowDrugFullName: this.$root.IsShowDrugFullName && this.$root.IsShowDrugFullName.trim() == `1`,
            eventOrderType: this.$root.eventOrderType || `1`,
            isShowTimeSS: this.$root.IsShowTimeSS,
            useDrugCommonTypesConfig: this.$root.UseDrugCommonTypesConfig && this.$root.UseDrugCommonTypesConfig.split(`|`).map(d => parseInt(d)) || [],
            configType: [],
            usageDrugEventCloseConfig: this.$root.UsageDrugEventCloseConfig
            // event_search_result:[]
        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
        }
        this.loadEventOrderType().then(() => {
            this.$store.dispatch(`ADD_WARD_AUTH`)
            this.$store.dispatch(`ADD_CURRENTUSER`)
            this.$store.dispatch(`drug/ADD_DRUG_TYPE`)
            this.$store.dispatch(`drug/ADD_DRUG_UNIT`)
            this.$store.dispatch(`drug/ADD_DRUG_WAY`)
            this.loadReadOnlyEvents().then(() => {
                this.loadDecimalPlaces()
                this.init()
                // this.loadKeyEventConfig()
                this.loadDicEventConfig()
                this.loadKeyDicEventConfig()
                this.loadPermissions()
                this.loadInfusionChannel()
                this.searchcompounddrug()
            })
        })
    },
    computed: {
        ...mapGetters([`ward_auth`, `currentUser`, `sys_enums`, `drug/drug_type`, `drug/drug_unit`, `drug/drug_way`, `screenHeight`]),
        screenHeight2() {
            return this.screenHeight
        },
        enumDrugType() {
            let that = this
            let allType = _.filter(this[`drug/drug_type`], d => !d.disabled)
            if (allType) {
                let configType = _.filter(allType, d => _.includes(that.useDrugCommonTypesConfig, d.value))
                if (configType && configType.length > 0) {
                    that.configType = configType.map(c => c.value).join(`|`)
                    allType.unshift({
                        label: `全部`,
                        value: -1
                    })
                }
                that.drug_type = allType && allType[0] && allType[0].value
            }
            console.log(`药品类别`, that.useDrugCommonTypesConfig, allType)
            return allType
        },
        event_search_result() {
            return _.filter(this.dic_event_config, d => {
                return (
                    !d.disabled &&
                    !d.disabled &&
                    (this.event_search_key.length == 0 || d.label.indexOf(this.event_search_key) > -1 || (this.event_search_key && d.jianpin && d.jianpin.indexOf(this.event_search_key.toUpperCase()) > -1))
                )
            })
        },
        // add by xiaorui ACIS-22769
        // 日期：2021-10-15,
        // 功能：当前用户有麻醉事件新增权限，才能新增麻醉事件
        hasNewEventPermission() {
            let r = false

            if (_.find(this.permissions, { no: `anesthesia_event_create` }) != undefined) {
                r = true
            }
            console.log(r)
            return r
        },
        // 日期：2022-03-10,
        // 功能：当前用户有麻醉事件修改权限，才能修改麻醉事件
        hasEditEventPermission() {
            let r = false

            if (_.find(this.permissions, { no: `anesthesia_event_edit` }) != undefined) {
                r = true
            }
            console.log(r)
            return r
        },
        columnListCompounddrug() {
            return [
                {
                    type: `table2`,
                    prop: `record_templates`,
                    label: { position: `top`, content: ` ` },
                    isEditable: true,
                    isCreatable: true,
                    options: [
                        {
                            type: `string`,
                            prop: `id`,
                            label: `排序`,
                            isKey: true
                        },
                        {
                            type: `string`,
                            label: `项目名称`,
                            prop: `dic_compound_drug_group_name`,
                            width: `320`,
                            isListable: true,
                            config: {
                                'popper-append-to-body': true
                            },
                            readonly: true
                        },
                        {
                            type: `bool`,
                            prop: `is_continue`,
                            label: `连续`,
                            isListable: true,
                            width: `60`,
                            readonly: true,
                            options: `enum_bool`
                        },
                        {
                            type: `datetime`,
                            prop: `begin_time`,
                            label: `开始时间`,
                            width: `180`,
                            isListable: true,
                            readonly: true,
                            config: {
                                datetimeFormate: this.isShowTimeSS == `1` ? `yyyy/MM/dd HH:mm:ss` : `yyyy/MM/dd HH:mm`,
                                noPadding: true,
                                editable: true
                            }
                        },
                        {
                            type: `datetime`,
                            prop: `end_time`,
                            label: `结束时间`,
                            width: `180`,
                            isListable: true,
                            readonly: true,
                            config: {
                                datetimeFormate: this.isShowTimeSS == `1` ? `yyyy/MM/dd HH:mm:ss` : `yyyy/MM/dd HH:mm`,
                                noPadding: true,
                                editable: true
                            }
                        },
                        {
                            type: `float`,
                            prop: `total_dose`,
                            label: `剂量`,
                            width: `60`,
                            isListable: true,
                            readonly: true,
                            default: 0
                        },
                        {
                            type: `select`,
                            prop: `unit`,
                            label: `单位`,
                            isListable: true,
                            width: `80`,
                            readonly: true,
                            config: {
                                'popper-append-to-body': true
                            },
                            options: _.filter(this[`drug/drug_unit`], { isconcentration: false, isspeed: false, disabled: false }).map(d => {
                                return {
                                    value: d.label,
                                    label: d.label
                                }
                            })
                        },
                        {
                            type: `float`,
                            prop: `concentration`,
                            label: `浓度`,
                            isListable: true,
                            decimal_places: this.decimalPlaces,
                            width: `60`,
                            readonly: true
                        },
                        {
                            type: `select`,
                            prop: `concentration_unit`,
                            label: `浓度单位`,
                            isListable: true,
                            width: `80`,
                            readonly: true,
                            options: _.filter(this[`drug/drug_unit`], { isconcentration: true, disabled: false }).map(d => {
                                return {
                                    value: d.label,
                                    label: d.label
                                }
                            })
                        },
                        {
                            type: `select`,
                            prop: `add_drug_way`,
                            label: `途径`,
                            isListable: true,
                            width: `120`,
                            config: {
                                'popper-append-to-body': true
                            },
                            readonly: true,
                            options: _.map(this[`drug/drug_way`], d => {
                                return {
                                    value: d.label,
                                    label: d.label,
                                    jianpin: d.jianpin
                                }
                            })
                        },

                        {
                            type: `select`,
                            prop: `dic_infusion_channel_id`,
                            label: `用药通道`,
                            width: `100`,
                            config: {
                                'popper-append-to-body': true
                            },
                            isListable: true,
                            readonly: true,
                            options: this.InfusionChannel
                        },
                        {
                            type: `string`,
                            prop: `remark`,
                            label: `备注`,
                            // width:"100",
                            isListable: true,
                            readonly: true
                        },
                        {
                            type: `buttongroup`,
                            prop: `oper`,
                            label: `操作`,
                            width: `100`,
                            isListable: true,
                            fixed: `right`,
                            options: (that, { row }) => {
                                return [
                                    {
                                        class: `is-plain is-circle`,
                                        label: ``,
                                        icon: `el-icon-edit`,
                                        type: `info`,
                                        emit: `editcompounddrug`,
                                        permission: `default`
                                    },
                                    {
                                        class: `is-plain is-circle`,
                                        label: ``,
                                        icon: `el-icon-close`,
                                        type: `danger`,
                                        emit: `removecompounddrug`,
                                        permission: `default`
                                    }

                                ]
                            }
                        }
                    ],
                    colspan: 24,
                    default: [],
                    config: {
                        showSequence: false,
                        height: this.screenHeight2 - 108
                    }
                }
            ]
        },
        columnList() {
            let isCreatePermission = this.hasNewEventPermission
            let isEditPermission = this.hasEditEventPermission
            let colOption = {}
            let me = this
            if (isCreatePermission || isEditPermission) {
                colOption = {
                    type: `autocomplete`,
                    label: `项目名称`,
                    prop: `drug_event_name`,
                    width: `320`,
                    isListable: true,
                    config: {
                        'popper-append-to-body': true
                    },
                    readonly: (that, { row }) => {
                        if (row.id > 0) {
                            if (row.item_type == -1) {
                                let roitem = _.find(me.readonly_events, x => { return x.id == row.drug_event_id && x.is_read_only })
                                return row.is_key_event || roitem
                            } else {
                                return true
                            }
                        } else {
                            return false
                        }
                    },
                    options: (that, { row }) => {
                        return q => {
                            if (row.item_type == -1) {
                                return this.dic_event_config
                                // return this.myaxios.get(`/api/AcisSystem/Event/SearchEvent`, q)
                            } else if (row.item_type) {
                                q.drugType = row.item_type
                                q.ck_actived = true
                                return this.myaxios.get(`/api/AcisSystem/Drug/SearchFidlerHospitalWard?surgeryid=${this.surgeryId}`, q)
                            } else {
                                return []
                            }
                        }
                    },
                    blurchange: (that, { changetext, changeid, index, row, prop, column }) => {
                        if (row.item_type > -1) {
                            if (changeid > 0) {
                                this.$set(row, `drug_event_name`, changetext)
                                this.$set(row, `drug_event_id`, changeid)
                                let req = this.myaxios.get(`/api/AcisSystem/Drug/Get/${row.drug_event_id}`)
                                req.then(data => {
                                    //   this.$set(row,'spec',data&&data.spec)
                                    this.$set(row, `dic_drug_full_name`, data && data.full_name)
                                    this.$set(row, `unit`, data && data.drug_unit)
                                    this.$set(row, `speed_unit`, data && data.speed_unit)
                                    this.$set(row, `speed_dose`, data && data.speed_dose)
                                    let thisdose = 0
                                    if (data && data.UseDose != null && data.UseDose != 0) {
                                        thisdose = data.UseDose
                                    } else {
                                        thisdose = data.dose
                                    }
                                    this.$set(row, `dose`, thisdose)
                                    this.$set(row, `add_drug_way`, data && data.add_drug_way)
                                    this.$set(row, `is_continue`, data && (data.is_continue || data.is_continue_way))
                                    if (data.enable_concentration) {
                                        this.$set(row, `concentration`, data && data.concentration || 0)
                                        this.$set(row, `concentration_unit`, data && data.concentration_unit)
                                    } else {
                                        this.$set(row, `concentration`, 0)
                                    }
                                    this.$set(row, `enable_concentration`, data && data.enable_concentration)
                                    this.$set(row, `occur_time`, this.$moment().format(`YYYY/MM/DD HH:mm:ss`))

                                    if (row.is_continue) {
                                        this.$set(row, `end_time`, this.$moment().format(`YYYY/MM/DD HH:mm:ss`))
                                    } else {
                                        this.$set(row, `end_time`, undefined)
                                    }
                                    if (row.is_empty) {
                                        this.$set(row, `is_empty`, false)
                                        this.mdata.record_templates.push({ is_empty: true, occur_time: this.$moment().format(`YYYY/MM/DD`) })
                                    }
                                    this.saveRow(row)
                                })
                            }
                        } else {
                            this.$set(row, `drug_event_name`, changetext)
                            this.$set(row, `drug_event_id`, changeid)
                            this.$set(row, `dic_drug_full_name`, undefined)
                            this.$set(row, `unit`, undefined)
                            this.$set(row, `speed_unit`, undefined)
                            this.$set(row, `speed_dose`, undefined)
                            this.$set(row, `dose`, undefined)
                            this.$set(row, `add_drug_way`, undefined)
                            this.$set(row, `is_continue`, undefined)
                            this.$set(row, `concentration`, undefined)
                            this.$set(row, `concentration_unit`, undefined)
                            this.$set(row, `enable_concentration`, false)
                            if (row.occur_time == this.$moment().format(`YYYY/MM/DD`)) {
                                this.$set(row, `occur_time`, this.$moment().format(`YYYY/MM/DD HH:mm:ss`))
                            }
                            if (row.is_empty) {
                                this.$set(row, `is_empty`, false)
                                this.mdata.record_templates.push({ is_empty: true, occur_time: this.$moment().format(`YYYY/MM/DD`) })
                            }
                            if (row.drug_event_name != ``) {
                                let req = that.myaxios.post(`/api/AcisSystem/Event/CustomEvent?name=${row.drug_event_name}`)
                                req.then(data => {
                                    this.$set(row, `drug_event_id`, data && data.id)
                                    this.$set(row, `drug_event_name`, data && data.name)
                                    this.saveRow(row)
                                }).catch(e => {
                                    console.log(e)
                                })
                            }
                        }
                    }
                }
            } else {
                colOption = {
                    type: `remoteselect`,
                    prop: `item`,
                    label: `项目名称`,
                    width: `260`,
                    isListable: true,
                    readonly: (that, { row }) => {
                        if (row.id > 0) {
                            return true
                        } else {
                            return false
                        }
                    },
                    config: {
                        'popper-append-to-body': true
                    },
                    options: (that, { row }) => {
                        return q => {
                            if (row.item_type == -1) {
                                // return this.dic_event_config
                                return this.myaxios.get(`/api/AcisSystem/Event/${me.eventOrderType == `1` ? `SearchEvent` : `SearchEventByorder`}`, q)
                            } else if (row.item_type) {
                                q.drugType = row.item_type
                                return this.myaxios.get(`/api/AcisSystem/Drug/Search`, q)
                            } else {
                                return []
                            }
                        }
                    },
                    change: (that, { row, area }) => {
                        if (row.item_type > -1) {
                            let req = this.myaxios.get(`/api/AcisSystem/Drug/Get/${row.item.value}`)
                            req.then(data => {
                                //   this.$set(row,'spec',data&&data.spec)
                                this.$set(row, `dic_drug_full_name`, data && data.full_name)
                                this.$set(row, `unit`, data && data.drug_unit)
                                this.$set(row, `speed_unit`, data && data.speed_unit)
                                this.$set(row, `speed_dose`, data && data.speed_dose)
                                let thisdose = 0
                                if (data && data.UseDose != null && data.UseDose != 0) {
                                    thisdose = data.UseDose
                                } else {
                                    thisdose = data.dose
                                }
                                this.$set(row, `dose`, thisdose)
                                this.$set(row, `add_drug_way`, data && data.add_drug_way)
                                this.$set(row, `is_continue`, data && (data.is_continue || data.is_continue_way))
                                this.$set(row, `enable_concentration`, data && data.enable_concentration)
                                if (data.enable_concentration) {
                                    this.$set(row, `concentration`, data && data.concentration || 0)
                                    this.$set(row, `concentration_unit`, data && data.concentration_unit)
                                } else {
                                    this.$set(row, `concentration`, 0)
                                }
                                this.$set(row, `occur_time`, this.$moment().format(`YYYY/MM/DD HH:mm:ss`))

                                if (row.is_continue) {
                                    this.$set(row, `end_time`, this.$moment().format(`YYYY/MM/DD HH:mm:ss`))
                                } else {
                                    this.$set(row, `end_time`, undefined)
                                }
                                if (row.is_empty) {
                                    this.$set(row, `is_empty`, false)
                                    this.mdata.record_templates.push({ is_empty: true, occur_time: this.$moment().format(`YYYY/MM/DD`) })
                                }
                                this.saveRow(row)
                            })
                        } else {
                            this.$set(row, `dic_drug_full_name`, undefined)
                            this.$set(row, `unit`, undefined)
                            this.$set(row, `speed_unit`, undefined)
                            this.$set(row, `speed_dose`, undefined)
                            this.$set(row, `dose`, undefined)
                            this.$set(row, `add_drug_way`, undefined)
                            this.$set(row, `is_continue`, undefined)
                            this.$set(row, `concentration`, undefined)
                            this.$set(row, `concentration_unit`, undefined)
                            this.$set(row, `enable_concentration`, false)
                            if (row.occur_time == this.$moment().format(`YYYY/MM/DD`)) {
                                this.$set(row, `occur_time`, this.$moment().format(`YYYY/MM/DD HH:mm:ss`))
                            }
                            if (row.is_empty) {
                                this.$set(row, `is_empty`, false)
                                this.mdata.record_templates.push({ is_empty: true, occur_time: this.$moment().format(`YYYY/MM/DD`) })
                            }
                            this.saveRow(row)
                        }
                    }
                }
            }
            console.log(`colOption`)
            console.log(colOption)
            return [
                {
                    type: `table2`,
                    prop: `record_templates`,
                    label: { position: `top`, content: ` ` },
                    isEditable: true,
                    isCreatable: true,
                    options: [
                        {
                            type: `string`,
                            prop: `id`,
                            label: `排序`,
                            isKey: true
                        },
                        {
                            type: `select`,
                            prop: `item_type`,
                            label: `项目类型`,
                            width: `100`,
                            isListable: true,
                            readonly: (that, { row }) => {
                                return row.id > 0
                            },
                            options: [{ label: `事件`, value: -1 }].concat(this[`drug/drug_type`]),
                            filters: true,
                            config: {
                                'popper-append-to-body': true
                            },
                            change: (that, { row, area }) => {
                                this.$delete(row, `item`)
                                if (row.item_type == -1) {
                                    this.$set(row, `class_name`, `eventCls`)
                                } else {
                                    this.$set(row, `class_name`, `drugCls`)
                                }
                                this.deleteRow(row)
                            }
                        },
                        colOption,
                        {
                            type: `string`,
                            prop: `dic_drug_full_name`,
                            label: `项目别名`,
                            width: `200`,
                            isListable: this.isShowDrugFullName,
                            readonly: true
                        },
                        {
                            type: `bool`,
                            prop: `is_continue`,
                            label: `连续`,
                            isListable: true,
                            width: `60`,
                            readonly: (that, { row }) => {
                                return row.is_key_event == true
                            },
                            options: `enum_bool`,
                            change: (that, { row, area }) => {
                                if (!row.is_continue) {
                                    this.$set(row, `end_time`, undefined)
                                }
                                this.saveRow(row)
                            }
                        },
                        {
                            type: `datetime`,
                            prop: `occur_time`,
                            label: `开始时间`,
                            width: `180`,
                            isListable: true,
                            readonly: (that, { row }) => {
                                if (row.item_type == -1) {
                                    let roitem = _.find(me.readonly_events, x => { return x.id == row.drug_event_id && x.is_read_only })
                                    if (roitem) {
                                        return true
                                    }
                                }
                                if (row.is_key_event && this.permissions && this.permissions.findIndex(item => item.permission === `Desltop:AdjustKeyEvent`) === -1) {
                                    return true
                                }
                                return false
                                // return this.permissions && this.permissions.findIndex(item => item.permission === `Desltop:AdjustKeyEvent`) != -1
                            },
                            config: {
                                datetimeFormate: this.isShowTimeSS == `1` ? `yyyy/MM/dd HH:mm:ss` : `yyyy/MM/dd HH:mm`,
                                noPadding: true,
                                editable: true
                            },
                            change: (that, { row, area }) => {
                                this.saveRow(row)
                            }
                        },
                        {
                            type: `datetime`,
                            prop: `end_time`,
                            label: `结束时间`,
                            width: `180`,
                            isListable: true,
                            readonly: (that, { row }) => {
                                // return row.item_type == -1 || !row.is_continue
                                return !row.is_continue
                            },
                            config: {
                                datetimeFormate: this.isShowTimeSS == `1` ? `yyyy/MM/dd HH:mm:ss` : `yyyy/MM/dd HH:mm`,
                                noPadding: true,
                                editable: true
                            },
                            change: (that, { row, area }) => {
                                this.saveRow(row)
                            }
                        },
                        {
                            type: `float`,
                            prop: `dose`,
                            label: `剂量`,
                            width: `60`,
                            isListable: true,
                            readonly: (that, { row }) => {
                                return row.item_type == -1
                            },
                            default: 0,
                            blur: (that, { row, area }) => {
                                this.saveRow(row)
                            }
                        },
                        {
                            type: `select`,
                            prop: `unit`,
                            label: `单位`,
                            isListable: true,
                            width: `80`,
                            readonly: (that, { row }) => {
                                return row.item_type == -1
                            },
                            config: {
                                'popper-append-to-body': true
                            },
                            options: _.filter(this[`drug/drug_unit`], { isconcentration: false, isspeed: false, disabled: false }).map(d => {
                                return {
                                    value: d.label,
                                    label: d.label
                                }
                            }),
                            change: (that, { row, area }) => {
                                this.saveRow(row)
                            }
                        },
                        {
                            type: `float`,
                            prop: `concentration`,
                            label: `浓度`,
                            isListable: true,
                            decimal_places: this.decimalPlaces,
                            width: `60`,
                            readonly: (that, { row }) => {
                                return row.item_type == -1 || !row.enable_concentration
                            },
                            blur: (that, { row, area }) => {
                                this.saveRow(row)
                            }
                        },
                        {
                            type: `select`,
                            prop: `concentration_unit`,
                            label: `浓度单位`,
                            isListable: true,
                            width: `80`,
                            readonly: (that, { row }) => {
                                return row.item_type == -1 || !row.enable_concentration
                            },
                            options: _.filter(this[`drug/drug_unit`], { isconcentration: true, disabled: false }).map(d => {
                                return {
                                    value: d.label,
                                    label: d.label
                                }
                            }),
                            change: (that, { row, area }) => {
                                this.saveRow(row)
                            }
                        },
                        {
                            type: `select`,
                            prop: `add_drug_way`,
                            label: `途径`,
                            isListable: true,
                            width: `120`,
                            config: {
                                'popper-append-to-body': true
                            },
                            readonly: (that, { row }) => {
                                return row.item_type == -1
                            },
                            options: _.map(this[`drug/drug_way`], d => {
                                return {
                                    value: d.label,
                                    label: d.label,
                                    jianpin: d.jianpin
                                }
                            }),
                            change: (that, { row, area }) => {
                                this.saveRow(row)
                            }
                        },

                        {
                            type: `select`,
                            prop: `dic_infusion_channel_id`,
                            label: `用药通道`,
                            width: `100`,
                            config: {
                                'popper-append-to-body': true
                            },
                            isListable: true,
                            readonly: (that, { row }) => {
                                return row.item_type == -1
                            },
                            options: this.InfusionChannel,
                            change: (that, { row, area }) => {
                                this.saveRow(row)
                            }
                            // default: this.InfusionChannel&&this.InfusionChannel[0]&&this.InfusionChannel[0].value
                        },
                        {
                            //   type: 'string',
                            //   prop: 'speed_dose',
                            //   readonly: (that,{row})=>{
                            //     return row.item_type==-1
                            //   },
                            //   label: '用药速度'
                            // }, {
                            //   type: 'string',
                            //   prop: 'speed_unit',
                            //   readonly: (that,{row})=>{
                            //     return row.item_type==-1
                            //   },
                            //   label: '流速单位'
                            // },{
                            type: `string`,
                            prop: `remark`,
                            label: `备注`,
                            // width:"100",
                            isListable: true,
                            readonly: (that, { row }) => {
                                return row.item_type > -1
                            },
                            blur: (that, { row, area }) => {
                                this.saveRow(row)
                            }
                        },
                        {
                            type: `buttongroup`,
                            prop: `oper`,
                            label: `操作`,
                            width: `60`,
                            isListable: true,
                            readonly: false,
                            fixed: `right`,
                            options: (that, { row }) => {
                                if (row.item_type == -1) {
                                    let roitem = _.find(me.nodeleted_events, x => { return x.id == row.drug_event_id && !x.can_be_deleted })
                                    if (roitem) {
                                        return []
                                    }
                                }
                                return row.is_empty || row.is_key_event
                                    ? []
                                    : [
                                        {
                                            class: `is-plain is-circle`,
                                            label: ``,
                                            icon: `el-icon-close`,
                                            type: `danger`,
                                            emit: `removeItem`,
                                            permission: `default`
                                        }
                                    ]
                            }
                        }
                    ],
                    colspan: 24,
                    default: [],
                    config: {
                        showSequence: false,
                        height: this.screenHeight2 - 108
                    }
                }
            ]
        },
        from1columnList() {
            return [{
                type: `string`,
                prop: `dic_compound_drug_group_name`,
                label: `名称`,
                isCreatable: true,
                isEditable: true,
                readonly: true,
                colspan: 12
            },
            {
                type: `select`,
                prop: `group_type_id`,
                label: `使用类型`,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                colspan: 12,
                options: this[`drug/drug_type`],
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            },
            {
                type: `select`,
                prop: `is_continue`,
                label: `是否连续`,
                width: `120`,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                options: `enum_bool`,
                colspan: 12,
                default: false,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            },
            {
                type: `float`,
                prop: `total_dose`,
                label: `总剂量`,
                width: `60`,
                isCreatable: true,
                colspan: 6,
                isEditable: true,
                default: 0,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            },
            {
                type: `select`,
                prop: `unit`,
                label: `单位`,
                width: `60`,
                isCreatable: true,
                colspan: 6,
                options: _.filter(this[`drug/drug_unit`], { isconcentration: false, isspeed: false, disabled: false }).map(d => {
                    return {
                        value: d.label,
                        label: d.label
                    }
                }),
                isEditable: true,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `float`,
                prop: `concentration`,
                label: `浓度`,
                isCreatable: true,
                isEditable: true,
                colspan: 12,
                decimal_places: this.decimalPlaces
            }, {
                type: `select`,
                prop: `concentration_unit`,
                label: `浓度单位`,
                isCreatable: true,
                isEditable: true,
                colspan: 12,
                options: _.filter(this[`drug/drug_unit`], { isconcentration: true, disabled: false }).map(d => {
                    return {
                        value: d.label,
                        label: d.label
                    }
                })
            }, {
                type: `select`,
                prop: `add_drug_way`,
                label: `途径`,
                config: {
                    'popper-append-to-body': true
                },
                isCreatable: true,
                isEditable: true,
                colspan: 12,
                options: _.map(this[`drug/drug_way`], d => {
                    return {
                        value: d.label,
                        label: d.label,
                        jianpin: d.jianpin
                    }
                })
            }, {
                type: `datetime`,
                prop: `begin_time`,
                label: `开始时间`,
                width: `180`,
                isCreatable: true,
                isEditable: true,
                colspan: 6,
                config: {
                    datetimeFormate: this.isShowTimeSS == `1` ? `yyyy/MM/dd HH:mm:ss` : `yyyy/MM/dd HH:mm`,
                    noPadding: true,
                    editable: true
                },
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            },
            {
                type: `datetime`,
                prop: `end_time`,
                label: `结束时间`,
                width: `180`,
                isCreatable: true,
                isEditable: true,
                colspan: 6,
                config: {
                    datetimeFormate: this.isShowTimeSS == `1` ? `yyyy/MM/dd HH:mm:ss` : `yyyy/MM/dd HH:mm`,
                    noPadding: true,
                    editable: true
                }
            }, {
                type: `select`,
                prop: `dic_infusion_channel_id`,
                label: `用药通道`,
                width: `100`,
                config: {
                    'popper-append-to-body': true
                },
                isListable: true,
                options: this.InfusionChannel
            }
            ]
        },
        listcolumnList() {
            return [
                {
                    type: `string`,
                    prop: `id`,
                    isKey: true,
                    label: `编号`
                },
                {
                    type: `string`,
                    prop: `dic_drug_name`,
                    label: `名称`,
                    isCreatable: true,
                    isEditable: true,
                    isListable: true,
                    readonly: true,
                    colspan: 12
                },
                {
                    type: `float`,
                    prop: `dose`,
                    label: `剂量`,
                    width: `60`,
                    isCreatable: true,
                    isEditable: true,
                    isListable: true,
                    readonly: false,
                    colspan: 6,
                    default: 0,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `select`,
                    prop: `unit`,
                    label: `单位`,
                    width: `60`,
                    isCreatable: true,
                    isEditable: true,
                    isListable: true,
                    readonly: false,
                    colspan: 6,
                    options: _.filter(this[`drug/drug_unit`], { isconcentration: false, isspeed: false, disabled: false }).map(d => {
                        return {
                            value: d.label,
                            label: d.label
                        }
                    }),
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                }, {
                    type: `float`,
                    prop: `concentration`,
                    label: `浓度`,
                    isCreatable: true,
                    isEditable: true,
                    isListable: true,
                    readonly: false,
                    colspan: 12,
                    decimal_places: this.decimalPlaces
                }, {
                    type: `select`,
                    prop: `concentration_unit`,
                    label: `浓度单位`,
                    isCreatable: true,
                    isEditable: true,
                    isListable: true,
                    readonly: false,
                    colspan: 12,
                    options: _.filter(this[`drug/drug_unit`], { isconcentration: true, disabled: false }).map(d => {
                        return {
                            value: d.label,
                            label: d.label
                        }
                    })
                }
            ]
        }
    },
    methods: {
        loadEventOrderType() {
            return new Promise((resolve) => {
                let req = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=EventOrderType`)
                req.then(data => {
                    if (data && data.value && data.value.trim()) {
                        this.eventOrderType = data.value
                        resolve(data.value)
                    }
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        loadReadOnlyEvents() {
            return new Promise((resolve) => {
                let req = this.myaxios.get(`/api/AcisSystem/Event/GetReadOnlyOrNoDeletedItems`)
                req.then(data => {
                    if (data) {
                        this.readonly_events = _.filter(data, x => x.is_read_only) || []
                        this.nodeleted_events = _.filter(data, x => !x.can_be_deleted) || []
                        console.log(`readonly_events`, this.readonly_events)
                        console.log(`nodeleted_events`, this.nodeleted_events)
                    }
                    resolve(data)
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        loadDecimalPlaces() {
            return new Promise((resolve) => {
                let req = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=ConcentrationDecimalPoint`)
                req.then(data => {
                    if (data && data.value && data.value.trim()) {
                        this.decimalPlaces = parseInt(data.value)
                    }
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        loadDicEventConfig() {
            return new Promise((resolve, reject) => {
                let req1 = this.myaxios.get(`/api/AcisSystem/KeyEventConfig/Configs`, { surgeryInfoId: this.surgeryId, recordType: this.recordType })
                let req2 = this.myaxios.get(`/api/AcisSystem/Event/${this.eventOrderType == `1` ? `SearchEvent` : `SearchEventByorder`}`)
                this.myaxios
                    .all(req1, req2)
                    .then(([keyEvents, events]) => {
                        events = events && _.filter(events, x => !x.disabled)
                        this.dic_event_config =
                            events &&
                            events.map(evt => {
                                return {
                                    value: evt.value,
                                    label: evt.label,
                                    jianpin: evt.jianpin,
                                    display_order: evt.display_order,
                                    disabled:
                                        _.findIndex(this.key_events, d => {
                                            return d.evt && !d.evt.is_deleted && d.evt.id == evt.value
                                        }) > -1
                                }
                            })
                        this.dic_event_keyvalues =
                            events &&
                            events.map(evt => {
                                return {
                                    value: evt.label,
                                    id: evt.value
                                }
                            })
                        resolve()
                    })
                    .catch(e => {
                        console.log(e)
                    })
            })
        },
        loadKeyDicEventConfig() {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/AcisSystem/Event/Search`)
                req.then(data => {
                    this.dic_key_eventnames =
                        data &&
                        data.map(d => {
                            return d.label
                        })
                    resolve()
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        loadInfusionChannel() {
            let req = this.myaxios.get(`/api/AcisSystem/InfusionChannel/Get`)
            req.then(data => {
                this.InfusionChannel =
                    data &&
                    data.map(d => {
                        return {
                            value: d.id,
                            label: d.name
                        }
                    })
            }).catch(e => {
                console.log(e)
            })
        },
        init() {
            this.removeItems = []
            let req1 = this.myaxios.get(`/api/Intraoperative/Anaesthesia/GetUseDrug?surgeryInfoId=${this.surgeryId}&recordType=${this.recordType}`)
            let req2 = this.myaxios.get(`/api/Intraoperative/Anaesthesia/GetUseCompoundDrug?surgeryInfoId=${this.surgeryId}&recordType=${this.recordType}`)
            let req3 = this.myaxios.get(`/api/AcisSystem/RecordTemplate/OccuredEvents?surgeryInfoId=${this.surgeryId}&recordType=${this.recordType}`)
            this.myaxios.all(req1, req2, req3).then(([drugs, compounddrugs, events]) => {
                this.key_events = _.filter(events, `is_key_event`)
                let dd = {}
                dd.record_templates =
                    _.map(_.orderBy(events, `occur_time`), d => {
                        return {
                            id: d.id,
                            is_key_event: d.is_key_event,
                            occur_time: d.occur_time,
                            end_time: d.end_time,
                            item_type: -1,
                            item: { value: d.dic_event_id, label: d.event_name },
                            drug_event_id: d.dic_event_id,
                            drug_event_name: d.event_name,
                            is_continue: d.is_continue, // d.end_time > d.occur_time,
                            biz_surgery_info_id: d.biz_surgery_info_id,
                            remark: d.remark,
                            class_name: `eventCls`
                        }
                    }) || []
                let usageDetails = []
                _.forEach(drugs, ds => {
                    let r = ds.usage_details.map(d => {
                        return {
                            id: d.id,
                            biz_surgery_info_id: d.biz_surgery_info_id,
                            occur_time: d.begin_time,
                            end_time: d.end_time,
                            item_type: ds.dic_drug_type_id,
                            item: { value: ds.dic_drug_id, label: ds.dic_drug_name, jianpin: ds.drug.abbr + ds.dic_drug_full_name },
                            drug_event_id: ds.dic_drug_id,
                            drug_event_name: ds.dic_drug_name,
                            dic_drug_full_name: ds.dic_drug_full_name,
                            dose: d.dose,
                            unit: d.unit,
                            concentration: d.concentration,
                            concentration_unit: d.concentration_unit,
                            enable_concentration: d.enable_concentration,
                            add_drug_way: d.add_drug_way,
                            is_continue: d.is_continue,
                            dic_infusion_channel_id: d.dic_infusion_channel_id,
                            class_name: `drugCls`
                            // remark:ds.remark
                        }
                    })
                    usageDetails.push(...r)
                })
                // 复合用药在这里
                console.log(`compounddrugs`)
                compounddrugs = _.map(compounddrugs, d => {
                    d.class_name = `drugCls`
                    return d
                }) || []
                let cdd = {}
                cdd.record_templates = compounddrugs
                cdd.record_templates = _.orderBy(cdd.record_templates, `begin_time`)
                this.compoundDrugdata = cdd
                let udst = _.orderBy(usageDetails, `occur_time`)
                dd.record_templates.push(...udst)
                dd.record_templates.push({ is_empty: true, occur_time: this.$moment().format(`YYYY/MM/DD`) })
                dd.record_templates = _.orderBy(dd.record_templates, `occur_time`)
                this.mdata = dd
            })
        },

        saveOne(autoSave) {
            // eslint-disable-next-line camelcase
            let record = this.mdata.record_templates
            // eslint-disable-next-line camelcase
            record = _.filter(record, d => !d.is_empty)
            let vld = _.findIndex(record, d => {
                return d.drug_event_name == `` || d.item_type.length == 0
            })
            if (vld > -1) {
                this.$message.warning(`项目或者项目类型不能为空`)
                return
            }
            vld = _.findIndex(record, d => {
                return d.item_type > -1 && (d.concentration == undefined || d.occur_time == undefined)
            })
            if (vld > -1) {
                this.$message.warning(`浓度/开始时间不能为空`)
                return
            }

            // 有权限新增时使用可编辑控件才判断
            let isCreatePermission = this.hasNewEventPermission
            let isEditPermission = this.hasEditEventPermission
            if (isCreatePermission || isEditPermission) {
                let addKeyEvents = _.filter(record, d => {
                    // 表示新添加或者把旧项目改成关键事件，这样不允许
                    console.log(this.dic_key_eventnames)
                    return this.dic_key_eventnames.indexOf(d.drug_event_name) > -1 && (d.is_key_event == undefined || d.is_key_event == false)
                })

                if (addKeyEvents && addKeyEvents.length > 0) {
                    let names = addKeyEvents.map(i => i.drug_event_name).join(`,`)
                    this.$message.warning(`不能新增关键事件。${names} 需要调整事件类型`)
                    return
                }
            }

            // let rescueSegments = []
            let reqs = _.map(record, (d, index) => {
                // // 获取抢救事件行
                // if (d.drug_event_name && (d.drug_event_name == `抢救开始` || d.drug_event_name == `抢救结束`)) {
                //     rescueSegments.push(d)
                // }
                if (d.is_continue == false) {
                    d.end_time = null
                }

                if (d.item_type > -1) {
                    d.begin_time = d.occur_time
                    console.log(`event`, d)
                    return this.myaxios[d.id > 0 ? `put` : `post`](`/api/Intraoperative/Anaesthesia/${d.id > 0 ? `PutUseDrug` : `PostUseDrug`}`, {
                        biz_surgery_info_id: this.surgeryId,
                        dic_drug_type_id: d.item_type,
                        dic_drug_id: isCreatePermission || isEditPermission ? d.drug_event_id : d.item.value,
                        enum_record_type: this.recordType,
                        usage_details: [d]
                    }).catch(e => {
                        console.log(e)
                        this.$message.error(e.data.detail)
                    })
                } else {
                    d.biz_surgery_info_id = this.surgeryId
                    d.enum_record_type = this.recordType
                    d.dic_event_id = isCreatePermission || isEditPermission ? d.drug_event_id : d.item.value
                    d.display_order = index + 1
                    console.log(`drug`, d)
                    return this.myaxios[d.id > 0 ? `put` : `post`](`/api/Intraoperative/Anaesthesia/${d.id > 0 ? `PutOccurEvent` : `PostOccurEvent`}`, d)
                }
            })
            let reqs2 = _.map(this.removeItems, d => {
                if (d.item_type > -1) {
                    return this.myaxios.delete(`/api/Intraoperative/Anaesthesia/DeleteUseDrug?useDrugDetailId=${d.id}`)
                } else {
                    return this.myaxios.delete(`/api/Intraoperative/Anaesthesia/DeleteOccurEvent?occurEventId=${d.id}`)
                }
            })
            reqs = reqs2.concat(reqs)
            return new Promise((resolve, reject) => {
                this.myaxios
                    .all(...reqs)
                    .then(data => {
                        let r = typeof winformMsg
                        if (r != `undefined`) {
                            _.forEach(data, (d, index) => {
                                if (d && _.has(d, `dic_drug_id`)) {
                                    console.log({ action: `drug`, data: { id: d.usage_details[0].id, is_delete: false } })
                                    winformMsg.acceptMessage({ action: `drug`, data: { id: d.usage_details[0].id, is_delete: false } })
                                } else if (d && _.has(d, `is_key_event`)) {
                                    console.log({ action: `event`, data: { id: d.id, is_delete: false } })
                                    winformMsg.acceptMessage({ action: `event`, data: { id: d.id, is_delete: false } })
                                } else if (this.removeItems[index] && this.removeItems[index].item_type > -1) {
                                    console.log({ action: `drug`, data: { id: this.removeItems[index].id, is_delete: true } })
                                    winformMsg.acceptMessage({ action: `drug`, data: { id: this.removeItems[index].id, is_delete: true } })
                                } else if (this.removeItems[index] && this.removeItems[index].item_type == -1) {
                                    console.log({ action: `event`, data: { id: this.removeItems[index].id, is_delete: true } })
                                    winformMsg.acceptMessage({ action: `event`, data: { id: this.removeItems[index].id, is_delete: true } })
                                }
                            })
                        }
                        this.$message.success(`保存成功`)
                        this.$refs[`close-btn`].close()
                        resolve()
                    })
                    .catch(e => reject(e))
            })
        },
        saveRow(row) {
            if (!this.usageDrugEventCloseConfig || this.usageDrugEventCloseConfig == `0`) return
            let that = this
            if (row.drug_event_name == `` || row.item_type.length == 0) {
                this.$message.warning(`项目或者项目类型不能为空`)
                return
            }
            if (row.item_type > -1 && (row.concentration == undefined || row.occur_time == undefined)) {
                this.$message.warning(`浓度/开始时间不能为空`)
            }

            // 有权限新增时使用可编辑控件才判断
            let isCreatePermission = this.hasNewEventPermission
            let isEditPermission = this.hasEditEventPermission
            if (isCreatePermission || isEditPermission) {
                if (this.dic_key_eventnames.indexOf(row.drug_event_name) > -1 && (row.is_key_event == undefined || row.is_key_event == false)) {
                    this.$message.warning(`不能新增关键事件。${row.drug_event_name} 需要调整事件类型`)
                }
            }

            let d = row
            if (d.is_continue == false) {
                d.end_time = null
            }

            if (d.item_type > -1) {
                d.begin_time = d.occur_time
                console.log(`event`, d)
                let req = this.myaxios[d.id > 0 ? `put` : `post`](`/api/Intraoperative/Anaesthesia/${d.id > 0 ? `PutUseDrug` : `PostUseDrug`}`, {
                    biz_surgery_info_id: this.surgeryId,
                    dic_drug_type_id: d.item_type,
                    dic_drug_id: isCreatePermission || isEditPermission ? d.drug_event_id : d.item.value,
                    enum_record_type: this.recordType,
                    usage_details: [d]
                })
                req.then(data => {
                    console.log({ action: `drug`, data: { id: data.usage_details[0].id, is_delete: false } })
                    winformMsg.acceptMessage({ action: `drug`, data: { id: data.usage_details[0].id, is_delete: false } })
                    that.init()
                }).catch(e => {
                    console.log(e)
                })
            } else {
                d.biz_surgery_info_id = this.surgeryId
                d.enum_record_type = this.recordType
                d.dic_event_id = isCreatePermission || isEditPermission ? d.drug_event_id : d.item.value
                d.display_order = 1
                console.log(`occur_event`, d)
                let req = this.myaxios[d.id > 0 ? `put` : `post`](`/api/Intraoperative/Anaesthesia/${d.id > 0 ? `PutOccurEvent` : `PostOccurEvent`}`, d)
                req.then(data => {
                    console.log({ action: `event`, data: { id: data.id, is_delete: false } })
                    winformMsg.acceptMessage({ action: `event`, data: { id: data.id, is_delete: false } })
                    that.init()
                }).catch(e => {
                    console.log(e)
                })
            }
        },
        SaveAs(row) {
            this.saveOne()
        },
        confirm($that) {
            if (this.activeHandle == `first` || this.activeHandle == `third`) {
                this.$refs[`form-saveas`].confirm()
            } else {
                this.$refs[`form-compounddrug`].confirm()
            }
        },
        removeItem({ index }) {
            let row = this.mdata.record_templates.splice(index, 1)[0]
            if (row.id) {
                this.removeItems.push(row)
            }
            this.deleteRow(row)
        },
        ExtraButtonClick(target) {
            this[target.emit] && this[target.emit](target)
        },
        searchDrugs() {
            let that = this
            // this.myaxios.get(`/api/AcisSystem/Drug/SearchFidlerHospitalWard?surgeryid=${this.surgeryId}`, q)
            console.log(`configType`, that.configType)
            console.log(`drug_type`, that.drug_type)
            let req = this.myaxios.get(`/api/AcisSystem/Drug/SearchFidlerHospitalWard?surgeryid=${this.surgeryId}`, { drugType: this.drug_type, keyword: this.drug_search_key })
            if (that.drug_type == -1) {
                req = this.myaxios.get(`/api/AcisSystem/Drug/SearchFidlerHospitalWard?surgeryid=${this.surgeryId}`, { allTypes: that.configType, keyword: this.drug_search_key })
            }
            req.then(data => {
                this.drug_search_result = _.filter(data, { disabled: false })
            }).catch(e => {
                this.drug_search_result = []
            })
        },
        searchcompounddrug() {
            let req = this.myaxios.get(`/api/AcisSystem/CompoundDrug/Search`, { keyword: this.compounddrug_search_key })
            req.then(data => {
                this.compounddrug_search_result = _.filter(data, { disabled: false })
            }).catch(e => {
                this.compounddrug_search_result = []
            })
        },
        usedrugbody(drug, data) {
            let drg = { ...drug }
            drg.label = data.name
            drg.value = data.id
            let drugType = this.drug_type
            if (this.drug_type == -1) {
                drugType = data.drug_types && data.drug_types[0] || ``
            }
            let newRow = {
                biz_surgery_info_id: this.surgeryId,
                item_type: drugType,
                item: drg,
                dic_drug_id: drg.value,
                drug_event_id: drg.value,
                drug_event_name: data.name,
                enum_record_type: this.recordType,
                occur_time: this.$moment().format(`YYYY/MM/DD HH:mm:ss`),
                dose: data.dose,
                unit: data.drug_unit,
                concentration: data.concentration || 0,
                concentration_unit: data.concentration_unit,
                enable_concentration: data.enable_concentration,
                add_drug_way: data.add_drug_way,
                is_continue: data.is_continue || data.is_continue_way,
                class_name: `drugCls`
            }
            this.mdata.record_templates.splice(-1, 0, newRow)
            this.saveRow(newRow)
        },
        useDrug(drug) {
            let that = this
            let req = that.myaxios.get(`/api/AcisSystem/Drug/Get/${drug.value}`)
            req.then(data => {
                that.usedrugbody(drug, data)
                that.setScrollTop()
            })
        },
        compounddruguseDrug(drug) {
            console.log(drug)
            let that = this
            if (drug.code == null || drug.code == undefined) {
                let req = that.myaxios.get(`/api/AcisSystem/CompoundDrug/GetDrugByGroupCode?groupCode=${drug.value}`)
                req.then(data => {
                    that.compoundDrug.dialogFormVisible = true
                    that.compoundDrug.fromdata.id = null
                    that.compoundDrug.fromdata.dic_compound_drug_group_code = drug.value
                    that.compoundDrug.fromdata.dic_compound_drug_group_name = drug.label
                    let r = _.map(data, d => {
                        return {
                            id: d.id,
                            dic_drug_id: d.id,
                            dic_drug_name: d.name,
                            dic_drug_full_name: d.full_name,
                            dose: d.dose,
                            unit: d.drug_unit,
                            concentration: d.concentration,
                            concentration_unit: d.concentration_unit
                        }
                    })
                    that.compoundDrug.listdata = r
                    console.log(data)
                    // data.forEach(d => {
                    //     that.utilityPromise = this.utilityPromise.then((g) => {
                    //         console.log()
                    //     })
                    // })
                })
            } else {
                let req = that.myaxios.get(`/api/AcisSystem/Drug/Get/${drug.value}`)
                req.then(data => {
                    that.usedrugbody(drug, data)
                    that.setScrollTop()
                })
            }
        },
        editcompounddrug({ index }) {
            let that = this
            let row = this.compoundDrugdata.record_templates[index]
            if (row.id) {
                that.compoundDrug.dialogFormVisible = true
                that.compoundDrug.fromdata = row
                that.compoundDrug.listdata = row.usage_details
            }
        },
        removecompounddrug({ index }) {
            let that = this
            let row = this.compoundDrugdata.record_templates[index]

            if (row.id) {
                this.$confirm(`是否确定删除?`, `提示`, {
                    confirmButtonText: `确定`,
                    cancelButtonText: `取消`,
                    type: `warning`
                }).then(() => {
                    let req = this.myaxios.delete(`/api/Intraoperative/Anaesthesia/DeleteUseDrugById?id=${row.id}`)
                    req.then(data => {
                        winformMsg.acceptMessage({ action: `compounddrug`, data: { id: row.id, is_delete: true } })
                        that.init()
                    }).catch(e => {
                        console.log(e)
                    })
                })
            }
        },
        deleteRow(row) {
            if (!this.usageDrugEventCloseConfig || this.usageDrugEventCloseConfig == `0`) return
            let that = this
            if (row.id) {
                if (row.item_type > -1) {
                    let req = this.myaxios.delete(`/api/Intraoperative/Anaesthesia/DeleteUseDrug?useDrugDetailId=${row.id}`)
                    req.then(data => {
                        console.log({ action: `drug`, data: { id: row.id, is_delete: true } })
                        winformMsg.acceptMessage({ action: `drug`, data: { id: row.id, is_delete: true } })
                        that.init()
                    }).catch(e => {
                        console.log(e)
                    })
                } else {
                    let req = this.myaxios.delete(`/api/Intraoperative/Anaesthesia/DeleteOccurEvent?occurEventId=${row.id}`)
                    req.then(data => {
                        console.log({ action: `event`, data: { id: row.id, is_delete: true } })
                        winformMsg.acceptMessage({ action: `event`, data: { id: row.id, is_delete: true } })
                        that.init()
                    }).catch(e => {
                        console.log(e)
                    })
                }
            }
        },
        useEvent(evt) {
            let newRow = {
                biz_surgery_info_id: this.surgeryId,
                item_type: -1,
                item: { ...evt },
                drug_event_id: evt.value,
                drug_event_name: evt.label,
                enum_record_type: this.recordType,
                occur_time: this.$moment().format(`YYYY/MM/DD HH:mm:ss`)
            }
            this.mdata.record_templates.splice(-1, 0, newRow)
            this.setScrollTop()
            this.saveRow(newRow)
        },
        setScrollTop() {
            this.$nextTick(() => {
                let scrollHeight = this.$refs[`form-saveas`].$refs[`ItemInput`][0].$children[0].$refs[`cus-table`].$refs.bodyWrapper.scrollHeight
                this.$refs[`form-saveas`].$refs[`ItemInput`][0].$children[0].$refs[`cus-table`].$refs.bodyWrapper.scrollTop = scrollHeight
            })
        },
        loadPermissions() {
            let req = this.myaxios.get(`/api/AcisSystem/Authorization/GetPermissions`) // 获取当前用户的权限
            req.then(data => {
                this.permissions = data
            }).catch(e => {
                console.log(e)
            })
        },
        savecompoundDrug(ddd) {
            this.$refs[`form-compoundDrug`].confirm()
        },
        savecompoundDrugIn(row) {
            let that = this
            if (row.end_time != null && row.end_time != undefined) {
                if (row.end_time.indexOf(`/Date`) > -1) {
                    row.end_time = this.isShowTimeSS == `1` ? this.$moment(row.end_time).format(`YYYY/MM/DD HH:mm:ss`) : this.$moment(row.end_time).format(`YYYY/MM/DD HH:mm`)
                }
                if (row.begin_time.indexOf(`/Date`) > -1) {
                    row.begin_time = this.isShowTimeSS == `1` ? this.$moment(row.begin_time).format(`YYYY/MM/DD HH:mm:ss`) : this.$moment(row.begin_time).format(`YYYY/MM/DD HH:mm`)
                }
                if (row.end_time < row.begin_time) {
                    this.$message.warning(`开始时间不允许大于结束时间！`)
                    return
                }
            }
            let fullname = ``
            console.log(`that.compoundDrug.listdata`)
            console.log(that.compoundDrug.listdata)
            let r = _.map(that.compoundDrug.listdata, d => {
                fullname += d.dic_drug_name + `(${d.dose}${d.unit})` + `+`
                return {
                    id: d.id,
                    dic_drug_id: d.dic_drug_id,
                    name: d.dic_drug_name,
                    dose: d.dose,
                    begin_time: row.begin_time,
                    end_time: row.end_time,
                    unit: d.unit,
                    concentration: d.concentration,
                    concentration_unit: d.concentration_unit
                }
            })
            console.log(r)
            if (fullname.length > 0) {
                fullname = fullname.slice(0, fullname.length - 1)
            }
            let usedrug = {
                id: row.id,
                biz_surgery_info_id: that.surgeryId,
                dic_drug_type_id: row.group_type_id,
                dic_drug_id: 0,
                total_dose: row.total_dose,
                unit: row.unit,
                enum_record_type: that.recordType,
                dic_compound_drug_group_code: row.dic_compound_drug_group_code,
                dic_compound_drug_group_name: fullname,
                group_type_id: row.group_type_id,
                is_continue: row.is_continue,
                begin_time: row.begin_time,
                end_time: row.end_time,
                concentration: row.concentration,
                concentration_unit: row.concentration_unit,
                add_drug_way: row.add_drug_way,
                dic_infusion_channel_id: row.dic_infusion_channel_id,
                usage_details: r
            }
            console.log(`usedrug`)
            console.log(usedrug)
            // this.myaxios[d.id > 0 ? `put` : `post`](`/api/Intraoperative/Anaesthesia/${d.id > 0 ? `PutUseDrug` : `PostUseDrug`}`
            let req = this.myaxios[usedrug.id > 0 ? `put` : `post`](`/api/Intraoperative/Anaesthesia/${usedrug.id > 0 ? `PutUseDrug` : `PostUseDrug`}`, usedrug)
            req.then(data => {
                console.log(data)
                that.compoundDrug.dialogFormVisible = false
                winformMsg.acceptMessage({ action: `compounddrug`, data: { id: data.id, is_delete: false } })
                // _.forEach(data, (d, index) => {
                //                 if (d && _.has(d, `dic_drug_id`)) {
                //                     console.log({ action: `drug`, data: { id: d.usage_details[0].id, is_delete: false } })
                //                     winformMsg.acceptMessage({ action: `drug`, data: { id: d.usage_details[0].id, is_delete: false } })
                //                 }  else if (this.removeItems[index] && this.removeItems[index].item_type > -1) {
                //                     console.log({ action: `drug`, data: { id: this.removeItems[index].id, is_delete: true } })
                //                     winformMsg.acceptMessage({ action: `drug`, data: { id: this.removeItems[index].id, is_delete: true } })
                //                 }
                //             })
                that.init()
            }).catch(e => {
                console.log(e)
            })
        }
    },
    watch: {
        drug_type: function() {
            this.searchDrugs()
        },
        drug_search_key: function() {
            this.searchDrugs()
        },
        compounddrug_search_key: function() {
            this.searchcompounddrug()
        }
    }
}
</script>
<style lang="less" scoped>
.usage-drug-event {
    .el-radio {
        width: 85px;
        margin: 5px 5px 0 0;
        overflow: hidden;
        .el-radio__input {
            display: none;
        }
        .el-radio__label {
            padding-left: 0;
            white-space: nowrap;
            text-align: justify;
            text-align-last: justify;
            display: inline-block;
            text-overflow: ellipsis;
            overflow: hidden;
            width: 100%;
        }
    }

    /deep/ .drugCls {
        color:#4285f4
    }
    /deep/ .eventCls {
        color:#274A5A
    }

    /deep/ .el-input__inner:focus{
        outline: 0;
        border-color: skyblue;
        background-color: skyblue;
        color: #ffffff;
        &::placeholder {
            color: #fff;
        }
    }

    /deep/ .el-table {
        font-size: 17px;
    }
    /deep/ .el-tabs__item {
        font-size: 17px;
    }
    /deep/ .el-divider__text{
        font-size: 17px;
    }
    /deep/ .el-radio.is-bordered{
        padding: 6px;
        margin-bottom: 4px;
    }
    /deep/ .el-radio{
        font-size: 17px;
    }
    /deep/ .el-link{
        font-size: 17px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Anesthsia/UsageDrugEvent.vue